<template>
  <apexchart type="bar" height="320" :options="chartOptions5" :series="series"></apexchart>
</template>

<script>

export default {
  name: 'AreaData',
  props: {
    title: {
      type: String
    },
    labels: {
      type: Array,
      default: () => {
        []
      },
    },
    series: {
      type: Array,
      default: () => {
        []
      },
    },
  },
  data() {
    return {
      series5: [],
      chartOptions5: {
        title: {
          text: '',
          align: 'left'
        },
        chart: {
          height: 350,
          type: 'bar',
          stacked: false,
        },
        stroke: {
          width: [0, 2, 5],
          curve: 'smooth',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            dataLabels: {
              position: 'top'
            }
          },
        },

        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100],
          },
        },
        labels: [],
        markers: {
          size: 0,
        },
        // xaxis: {
        //   type: 'datetime',
        // },
        yaxis: {
          // title: {
          //   text: 'Points',
          // },
          min: 0,
        },
        tooltip: {
          shared: true,
          intersect: false,
          // y: {
          //   formatter: function (y) {
          //     if (typeof y !== "undefined") {
          //       return y.toFixed(0) + " points";
          //     }
          //     return y;
          //
          //   }
          // }
        },
      },
    }
  },
  created() {
    // this.getData()
    this.chartOptions5 = {
      plotOptions: {
        bar: {
          columnWidth: '50%',
          dataLabels: {
            position: 'top'
          }
        },
      },
      title: {
        text: this.title,
        align: 'left'
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ['#000']
        },
        offsetY: -15,
      },
      labels: this.labels,
    }
  },
  methods: {
  },
}
</script>

<style scoped>

</style>
